// extracted by mini-css-extract-plugin
export default {"footer":"FooterSimple_footer__zBeVv","inner":"FooterSimple_inner__B8xBU","links":"FooterSimple_links__5Tw7C"};